export default __webpack_public_path__ + "static/media/our-services-edu-secondary-01.a78bd1f6.jpg";